import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["intersector", "block", "height", "container", "mirror", "title"]

  connect() {
    console.log("scroll connect")
    this.addShadow()
  }

  disconnect() {
  }

  addShadow() {
    const header = this.containerTarget
    const list = this.blockTarget
    const height = this.heightTarget

    if (this.hasIntersectorTarget) {
      const scrollMarker = this.intersectorTarget
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const intersecting = entry.isIntersecting

          header.classList.toggle("shadow-md", !intersecting)
          list.classList.toggle("hidden", intersecting)
          list.classList.toggle("flex", !intersecting)
          height.classList.toggle("h-0", intersecting)

          if (this.hasTitleTarget) {
            const el = this.titleTarget

            // Dodaj animację fontu tylko raz
            el.classList.add("transition-font", "duration-300", "ease-in-out")

            if (!intersecting) {
              el.classList.remove("text-2xl", "sm:text-2xl")
              el.classList.add("text-base", "sm:text-lg")
            } else {
              el.classList.remove("text-base", "sm:text-lg")
              el.classList.add("text-2xl", "sm:text-2xl")
            }
          }
        })
      }, {})

      observer.observe(scrollMarker)
    } else {
      header.classList.add("shadow-md")
      list.classList.remove("hidden")
      list.classList.add("flex")
      height.classList.remove("h-0")

      if (this.hasTitleTarget) {
        const el = this.titleTarget
        el.classList.add("transition-font", "duration-300", "ease-in-out")
        el.classList.remove("text-2xl", "sm:text-2xl")
        el.classList.add("text-base", "sm:text-lg")
      }
    }
  }
}
